export function InsertDivider (pEditor, pDivider)
{
  this.openInsertDividerDialog = (pButton) =>
  {
    let elementBaseId = (pButton && pButton.getDialog()) ? pButton.getAttribute('id') + '_Dialog' : BEditor.Dialogs['Divider'].id;

    pEditor.pDialog = (pButton && pButton.getDialog()) ? pButton.getDialog() : BEditor.Dialogs['Divider'].dialog;

    if (!pEditor.pDialog)
    {
      return false;
    }

    pEditor.range.save();

    BEditor.domHelpers.$(elementBaseId + '_SaveButton').onclick = function () { insertDivider(pButton); };
    BEditor.domHelpers.$(elementBaseId + '_CancelButton').onclick = function () {  pDivider.editor.closeEditDividerDialog(pButton); };

    pEditor.pDialog.callBackParameters.cssClass = 'divider_style_border_dotted';
    pEditor.pDialog.callBackParameters.inlineStyle = '';
    pEditor.pDialog.callBackParameters.themeResources = BEditor.Config.getThemeStyles();

    if (!pEditor.pDialog.isCancelHandler)
    {
      pEditor.pDialog.Cancel.addHandler(function() { pDivider.editor.closeEditDividerDialog(pButton); });
      pEditor.pDialog.isCancelHandler = true;
    }

    pEditor.pDialog.show();

    pEditor.afterOpenDialog();
  };


  function insertDivider (pButton)
  {
    let currentSelection,
        currentRange,
        cssClass,
        inlineStyle,
        imgTag,
        divider,
        dividerParentElement;

    if (pEditor.pDialog)
    {
      let parameters = pEditor.pDialog.getParameters();

      if (!parameters)
      {
        return false;
      }

      cssClass = parameters.cssClass;
      inlineStyle = parameters.inlineStyle;

      pEditor.closeDialog();

      currentSelection = pEditor.range.selection.getCurrent();
      currentRange = pEditor.range.getCurrent();

      if (currentRange)
      {
        imgTag = '<img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" class="WaContentDivider' + (cssClass ? ' ' + cssClass : '') + '" ' + (inlineStyle ? 'style="' + inlineStyle + '" ' : '') + 'data-WaComponentType="ContentDivider" data-wanewdivider="1">';

        if (BEditor.browser.isIE)
        {
          if (currentSelection && currentSelection.type.toUpperCase() == 'CONTROL')
          {
            currentRange.item(0).outerHTML = imgTag;
          }
          else
          {
            currentRange.collapse(false);
            currentRange.pasteHTML(imgTag);
          }
        }
        else
        {
          currentRange.insertNode(currentRange.createContextualFragment(imgTag));
        }

        divider = pEditor.iFrameDoc.body.querySelector('IMG[data-wanewdivider="1"]');

        if (divider)
        {
          dividerParentElement = divider.parentNode;

          if (dividerParentElement.innerHTML.replace(/^(?:<BR>|&nbsp;|\s)*(<IMG\s[^>]*>)(?:<BR>|&nbsp;|\s)*$/i, '$1') === dividerParentElement.outerHTML.replace(/^<(?:P|H[1-7]|DIV)(?:\s[^>]*>|>)(?:<BR>|&nbsp;|\s)*(<IMG\s[^>]*>)(?:<BR>|&nbsp;|\s)*<\/(?:P|H[1-7]|DIV)>$/i, '$1'))
          {
            dividerParentElement.outerHTML = imgTag.replace(/ data-wanewdivider="1"/, '');
          }

          divider.removeAttribute('data-wanewdivider');
        }

        pEditor.range.save();
      }
    }
  }
}